import React, { FC } from 'react';

import { Button } from '@/ui-kit/web';

import { useCookiesConsent } from '@/services/segment/Context';

interface CookiesButtonProps {
  pageContext: Queries.getPagesQuery['allStrapiLandingPageV2']['nodes'][number];
}

const getText = (locale: string) => {
  switch (locale) {
    case 'de':
      return 'Cookies bearbeiten';
    case 'en':
      return 'Manage cookies';
    case 'fr':
      return 'Gestion des cookies';
    case 'it':
      return 'Gestisci i cookie';
    case 'es':
      return 'Gestionar cookies';
    case 'pt':
      return 'Gestão de cookies';
    default:
      return 'Manage cookies';
  }
};

export const CookiesButton: FC<CookiesButtonProps> = ({ pageContext }) => {
  const locale = pageContext.locale || 'en';
  const { setForcedOpen: setForcedShown } = useCookiesConsent();

  return (
    <Button type="plaintext" onClick={() => setForcedShown(true)}>
      {getText(locale)}
    </Button>
  );
};
